export default __webpack_public_path__ + "e7b2e69893d1c3ed752f4cead534d08f.svg";